export default window._cmsContent['whd/update-details']